<mat-dialog-content>
    <app-content [uri]="uri"></app-content>
</mat-dialog-content>

<div class="row">
    <div class="col-sm-12 align-self-center">
        <app-button-close (action)="close()"></app-button-close>
    </div>
</div>